import React from "react";
import SvgInline from "./svgInline";

function dividerStyle(props) {
  if (props.style === "zigzag_tribal") {
    return (
      <SvgInline
        url="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 120 26' fill='%2314BAB0' stroke='none'%3E%3Cpolygon points='0,14.4 0,21 11.5,12.4 21.3,20 30.4,11.1 40.3,20 51,12.4 60.6,20 69.6,11.1 79.3,20 90.1,12.4 99.6,20 109.7,11.1 120,21 120,14.4 109.7,5 99.6,13 90.1,5 79.3,14.5 71,5.7 60.6,12.4 51,5 40.3,14.5 31.1,5 21.3,13 11.5,5  '/%3E%3C/svg%3E"
        style={props}
      />
    );
  } else if (!props.style) {
    return (
      <div
        style={{
          height: `${props.weight.size + props.weight.unit}`,
          width: `${props.width.size + props.width.unit}`,
          background: `${props.color}`,
        }}
      ></div>
    );
  } else {
    return <div>a</div>;
  }
}

const Divider = (props) => {
  return dividerStyle(props);
};
export default Divider;
